/**
 * Tabs.js — wires up any [data-tabs] group of [data-tab] triggers to show/hide
 * matching [data-tab-content] panels. Triggers without a data-tab (dividers,
 * sort links) are left untouched.
 */
export default class Tabs {
  constructor(selector = '[data-tabs]') {
    this.groups = document.querySelectorAll(selector);
    if (!this.groups.length) return;

    this.groups.forEach((group) => this._bindGroup(group));
  }

  _bindGroup(group) {
    const triggers = group.querySelectorAll('[data-tab]');
    if (!triggers.length) return;

    const panels = document.querySelectorAll('[data-tab-content]');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        const link = trigger.querySelector('a');
        if (link) e.preventDefault();

        const target = trigger.dataset.tab;

        triggers.forEach((t) => t.classList.toggle('active', t === trigger));
        panels.forEach((panel) => {
          panel.classList.toggle('hidden', panel.dataset.tabContent !== target);
        });
      });
    });
  }
}
